export const rawLocale = {
  ascending: {
    en: "Ascending",
    ru: "По возрастающей",
    es: "Ascendente",
    zh: "升序",
  },
  browse: {
    en: "Browse",
    ru: "Обзор",
    es: "Navegar",
    zh: "浏览",
  },
  code_desc: {
    en: "You can directly copy and paste this code snippet at the bottom of the ScreamAPI config file",
    ru: "Вы можете напрямую скопировать и вставить данный фрагмент кода в конец конфигуграционного файла ScreamAPI",
    es: "Puedes copiar y pegar este retazo de código directamente al fondo del archivo de configuración de ScreamAPI",
    zh: "您可以直接将以下代码复制并粘贴至 ScreamAPI 配置文件底部",
  },
  copy: {
    en: "Copy",
    ru: "Скопировать",
    es: "Copiar",
    zh: "复制",
  },
  browse_games: {
    en: "Browse Games",
    ru: "Обзор Игр",
    es: "Navega juegos",
    zh: "浏览游戏",
  },
  clear_all: {
    en: "Clear all",
    ru: "Убрать все",
    es: "Limpiar todo",
    zh: "清空",
  },
  descending: {
    en: "Descending",
    ru: "По убывающей",
    es: "Descendiente",
    zh: "降序",
  },
  filter_by_offer_type: {
    en: "Filter by offer type",
    ru: "Фильтр по типу контента",
    es: "Filtrar por tipo de oferta",
    zh: "按订单类型过滤",
  },
  found_games: {
    en: "Found games",
    ru: "Найдено игр",
    es: "Juegos encontrados",
    zh: "已找到游戏",
  },
  home: {
    en: "Home",
    ru: "Домой",
    es: "Hogar",
    zh: "主页",
  },
  id: {
    en: "ID",
    ru: "ID",
    es: "ID",
    zh: "ID",
  },
  image: {
    en: "Image",
    ru: "Изображение",
    es: "Imagen",
    zh: "图像",
  },
  lang: {
    en: "English",
    ru: "Русский",
    es: "Español",
    zh: "中文（简体）",
  },
  multiple_items: {
    en: "Multiple items",
    ru: "Несколько предметов",
    es: "Múltiples elementos",
    zh: "多项",
  },
  no_offers: {
    en: "No offers found",
    ru: "Не найдено дополнительного контента",
    es: "No se han encontrado ofertas",
    zh: "未找到订单",
  },
  no_games: {
    en: "No games found",
    ru: "Не найдено игр",
    es: "No se han encontrado juegos",
    zh: "未找到游戏",
  },
  not_found: {
    en: "Page not found",
    ru: "Страница не найдена",
    es: "Página no encontrada",
    zh: "未找到页面",
  },
  offer_type: {
    en: "Offer type",
    ru: "Тип контента",
    es: "Tipo de oferta",
    zh: "订单类型",
  },
  search_by_id: {
    en: "Search by ID",
    ru: "Поиск по ID",
    es: "Buscar por ID",
    zh: "按ID搜索",
  },
  search_games: {
    en: "Search for games",
    ru: "Поиск игр",
    es: "Busca juegos",
    zh: "搜索游戏",
  },
  select_all: {
    en: "Select all",
    ru: "Выбрать все",
    es: "Seleccionar todo",
    zh: "全选",
  },
  settings: {
    en: "Settings",
    ru: "Настройки",
    es: "Configuración",
    zh: "设置",
  },
  showing_offers: {
    en: "Offers for ",
    ru: "Контент для ",
    es: "Contenido para ",
    zh: "以下游戏的结果",
  },
  sort_by: {
    en: "Sort by",
    ru: "Сортировать по",
    es: "Ordenar por",
    zh: "排序方式",
  },
  sort_creation_date: {
    en: "Creation date",
    ru: "Дате создания",
    es: "Fecha de creación",
    zh: "公开日期",
  },
  sort_current_price: {
    en: "Current price",
    ru: "Цене",
    es: "Precio",
    zh: "当前价格",
  },
  sort_new_release: {
    en: "New release",
    ru: "Новинке",
    es: "Nuevo lanzamiento",
    zh: "最新推出",
  },
  sort_release_date: {
    en: "Release date",
    ru: "Дате выхода",
    es: "Fecha de lanzamiento",
    zh: "推出日期",
  },
  sort_relevance: {
    en: "Relevance",
    ru: "Актуальности",
    es: "Relevancia",
    zh: "相关性",
  },
  sort_title: {
    en: "Title",
    ru: "Названию",
    es: "Título",
    zh: "标题",
  },
  title: {
    en: "Title",
    ru: "Название",
    es: "Título",
    zh: "标题",
  },
  version: {
    en: "Version",
    ru: "Версия",
    es: "Versión",
    zh: "版本",
  },
  view_on_epic_store: {
    en: "Open in Epic Games Store",
    ru: "Открыть в магазине Epic Games ",
    es: "Abrir en la tienda de Epic Games",
    zh: "在Epic游戏商城中查看",
  },
};
